<div class="nt-painel-topo mat-bg-primary">
  <h6 class="m-0">Notificações</h6>
  <span class="nt-painel-novas" *ngIf="totalNovas > 0">{{ totalNovas }} {{ totalNovas === 1 ? 'nova' : 'novas' }}</span>
  <span fxFlex></span>
  <button mat-icon-button *ngIf="totalNovas > 0" (click)="marcarTodasLidas($event)"
          matTooltip="Marcar todas como lidas" aria-label="Marcar todas como lidas">
    <mat-icon>done_all</mat-icon>
  </button>
  <button mat-icon-button (click)="closePanel()" matTooltip="Fechar" aria-label="Fechar painel de notificações">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-nav-list class="notification-list" role="list">
  <mat-list-item *ngFor="let n of notifications | async" class="notific-item" role="listitem"
                 [class.nt-item-nova]="$any(n)._nova"
                 [style.--nt-cor]="visual(n).cor" [style.--nt-cor-suave]="visual(n).corSuave">
    <span class="nt-item-icone"><mat-icon>{{ visual(n).icone }}</mat-icon></span>

    <ng-container *ngIf="isCompromisso(n); else notifDefault">
      <a [routerLink]="n.outrosDados" (click)="closePanel()">
        <div class="mat-list-text">
          <h4 class="message">{{ n.titulo }}</h4>
          <small class="time text-muted" *ngIf="getCompromissoResponsavel(n)">👤 {{ getCompromissoResponsavel(n) }}</small>
          <small class="time text-muted">
            Prazo: {{ n.inicio | date:'dd/MM/yyyy' }}<span *ngIf="getCompromissoHorario(n)"> · ⏰ {{ getCompromissoHorario(n) }}</span>
          </small>
        </div>
      </a>
    </ng-container>

    <ng-template #notifDefault>
      <a (click)="$event.preventDefault(); openPopUp(n)">
        <div class="mat-list-text">
          <h4 class="message">{{ n.titulo }}</h4>
          <small class="nt-item-resumo" *ngIf="$any(n)._resumo">{{ $any(n)._resumo }}</small>
          <small class="time nt-item-rodape">
            <span class="nt-item-tipo">{{ visual(n).rotulo }}</span>
            <span *ngIf="n.inicio"> · {{ n.inicio | date:'dd/MM/yyyy' }}</span>
            <span *ngIf="n.fromInfokaw" matTooltip="Enviada pela Infokaw"> · Infokaw</span>
          </small>
        </div>
      </a>
      <span class="nt-item-ponto" *ngIf="$any(n)._nova" matTooltip="Não lida"></span>
    </ng-template>
  </mat-list-item>

  <div *ngIf="this.notificPanel.totalNotif === 0" class="nt-vazio">
    <mat-icon>notifications_none</mat-icon>
    <div>Tudo em dia</div>
    <small>Nenhuma notificação no momento.</small>
  </div>
</mat-nav-list>

<div class="text-center mt-1 mb-1" *ngIf="this.notificPanel.totalNotif > 0">
  <small><a href="#" (click)="clearAll($event)">{{ 'CLEAR_NOTIFICATION' | translate }}</a></small>
</div>
